import classNames from "classnames";
import React, { MouseEventHandler } from "react";
import { READ_MORE_DEFAULT_HEIGHT } from "shared/utils/styleConstants";
import ToolTip from "../tooltip";
import Translation from "../translation";

function ReadMore({
  height = READ_MORE_DEFAULT_HEIGHT,
  additionalClassName = "",
  ...props
}: {
  title?: React.ReactNode;
  content: string;
  isHTMLFormatted?: boolean;
  height?: number;
  additionalClassName?: string;
  paragraphLines?: number;
  /* Will perform click action instead of showing tooltip */
  onClick?: MouseEventHandler;
}) {
  const ref = React.useRef<any>();
  const isOverflow = useIsOverflow(ref, () => {});

  return (
    <span
      className={classNames("readMoreWrapper", additionalClassName)}
      ref={ref}
      style={{ height: isOverflow ? height : "auto", WebkitLineClamp: props.paragraphLines }}>
      {props.title}
      {props.isHTMLFormatted ? (
        <span
          dangerouslySetInnerHTML={{
            __html: props.content
          }}
        />
      ) : (
        <span>{props.content}</span>
      )}
      {props.onClick
        ? isOverflow && (
            <span className="linkOnlyWrapper">
              <span onClick={props.onClick}>
                ...&nbsp;
                <Translation name="read.more" />
              </span>
            </span>
          )
        : isOverflow && (
            <ToolTip
              trigger={"click"}
              overlayClassName="readMoreTooltip"
              content={props.content}
              isHTMLFormatted={props.isHTMLFormatted}>
              <span>
                ...&nbsp;
                <Translation name="read.more" />
              </span>
            </ToolTip>
          )}
    </span>
  );
}

export default ReadMore;

export const useIsOverflow = (ref: any, callback: { (isOverflowFromCallback: any): void; (arg0: boolean): void }) => {
  const [isOverflow, setIsOverflow] = React.useState<boolean>();

  React.useEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight;

      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };

    if (current) {
      if ("ResizeObserver" in window) {
        new ResizeObserver(trigger).observe(current);
      }

      trigger();
    }
  }, [callback, ref]);

  return isOverflow;
};
